import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'profile-input',
  props: {
    lang: {
      type: Object
    }
  },
  data: () => ({
    userFieldsLoaded: false,
    modalOpened: false
  }),
  computed: {
    ...mapState('auth', ['user', 'isUpdateProfilePending']),
    ...mapGetters('auth', ['haveProfileData', 'isProfilePending']),
    scope() {
      return {
        profile: this.user,
        haveProfileData: this.haveProfileData,
        isProfilePending: this.isProfilePending,
        modalOpened: this.modalOpened,
        toggleModal: this.toggleModal,
      }
    }
  },
  async mounted() {
    if (this.lang) {
      await this.registerScopedLang({ scope: 'profile', lang: this.lang })
    }
    if (!this.haveProfileData && !this.isProfilePending) {
      await this.getProfile()
    }
  },
  methods: {
    ...mapActions('auth', ['getProfile']),
    ...mapActions('i18n', ['registerScopedLang']),
    toggleModal() {
      this.modalOpened = !this.modalOpened
    }
  },
  render() {
    return this.$scopedSlots.default(this.scope)
  }
}